import React, { useState } from "react";
import { Link } from "react-router-dom";

import avatar20 from "../../assets/images/avatar-20.png"
import avatar23 from "../../assets/images/avatar-23.png"
import avatar19 from "../../assets/images/avatar-19.png"
import { TaskActivityChart } from "./AllProjectDashCharts";

const TaskActivity = () => {

  const [isDropdownVisible, setDropdownVisibility] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisibility(!isDropdownVisible);
  };

  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-1 2xl:grid-cols-12">
        <div className="gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder 2xl:col-span-8 border-black/10">
          <div className="flex items-center justify-between gap-4 mb-4">
            <h2 className="text-base font-semibold text-black dark:text-white/80">
              Task Activity
            </h2>
            <div>
              <div x-data="{ dropdown: false}" className="ml-auto dropdown">
                <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown}>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                      fill="currentColor"
                    ></path>
                    <path
                      d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                      fill="currentColor"
                    ></path>
                    <path
                      d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </Link>
                {isDropdownVisible && (
                <ul className="ltr:right-0 rtl:left-0 whitespace-nowrap">
                  <li>
                    <Link to="#">Weekly</Link>
                  </li>
                  <li>
                    <Link to="#">Monthly</Link>
                  </li>
                  <li>
                    <Link to="#">Yearly</Link>
                  </li>
                </ul>
                )}
              </div>
            </div>
          </div>
          <div>
            <div id="chart5" className="-ml-4">
              <TaskActivityChart />
            </div>
          </div>
        </div>
        <div className="bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10 2xl:col-span-4">
          <div className="gap-6 p-5 pb-4">
            <h2 className="text-base font-semibold text-black capitalize dark:text-white/80">
              Today's Tasks
            </h2>
          </div>
          <div className="flex flex-col gap-3 h-[320px]  overflow-y-auto px-5">
            <Link
              to="#!"
              className="block p-3 border rounded-md dark:border-darkborder border-black/10"
            >
              <h6 className="mb-3 text-black truncate dark:text-white/80">
                Chat Application Design
              </h6>
              <div className="flex items-center gap-2">
                <img
                  src={avatar20}
                  alt=""
                  className="rounded-full size-8"
                />
                <div className="grow">
                  <p className="text-xs text-muted">Assigned To</p>
                  <h6 className="text-sm text-black dark:text-white/80">
                    Natali Craig
                  </h6>
                </div>
              </div>
            </Link>
            <Link
              to="#!"
              className="block p-3 border rounded-md dark:border-darkborder border-black/10"
            >
              <h6 className="mb-3 text-black truncate dark:text-white/80">
                HR Management System
              </h6>
              <div className="flex items-center gap-2">
                <img
                  src={avatar23}
                  alt=""
                  className="rounded-full size-8"
                />
                <div className="grow">
                  <p className="text-xs text-muted">Assigned To</p>
                  <h6 className="text-sm text-black dark:text-white/80">
                    Catherine
                  </h6>
                </div>
              </div>
            </Link>
            <Link
              to="#!"
              className="block p-3 border rounded-md dark:border-darkborder border-black/10"
            >
              <h6 className="mb-3 text-black truncate dark:text-white/80">
                Responsive Not Working
              </h6>
              <div className="flex items-center gap-2">
                <img
                  src={avatar19}
                  alt=""
                  className="rounded-full size-8"
                />
                <div className="grow">
                  <p className="text-xs text-muted">Assigned To</p>
                  <h6 className="text-sm text-black dark:text-white/80">
                    Kate Morrison
                  </h6>
                </div>
              </div>
            </Link>
            <Link
              to="#!"
              className="block p-3 border rounded-md dark:border-darkborder border-black/10"
            >
              <h6 className="mb-3 text-black truncate dark:text-white/80">
                Redesign My Website
              </h6>
              <div className="flex items-center gap-2">
                <img
                  src={avatar20}
                  alt=""
                  className="rounded-full size-8"
                />
                <div className="grow">
                  <p className="text-xs text-muted">Assigned To</p>
                  <h6 className="text-sm text-black dark:text-white/80">
                    Natali Craig
                  </h6>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TaskActivity;
